firebird.controller('webinarPresenterQAModalCtrl', [
    '$rootScope',
    '$scope',
    '$window',
    'logService',
    'questionService',
    'socketService',
    'meetingService',
    'contentService',
    'pollingService',
    'helperService',
    'brandingService',
    'localizationService',
    function (
        $rootScope,
        $scope,
        $window,
        logService,
        questionService,
        socketService,
        meetingService,
        contentService,
        pollingService,
        helperService,
        brandingService,
        localizationService
    ) {
        var self = this;
        const logger = logService.createLoggerWithSource('webinarPresenterQAModalCtrl');

        self.newQuestions = [];
        self.answeredQuestions = [];
        self.ignoredQuestions = [];

        self.onShowModal = onShowModal;
        self.onHideModal = onHideModal;
        self.modalState = 'closed';

        self.toggleTab = toggleTab;
        self.tab = 'new';
        self.spaceFilerText = localizationService.translate('Q_AND_A.PERHAPS_A_COUPLE_MORE_QUESTIONS');

        self.mode = 'question-list';

        self.checkForModificationAndSetMode = checkForModificationAndSetMode;
        self.setMode = setMode;
        self.getTitle = getTitle;

        self.droppedItem = droppedItem;

        self.resetQuestionFields = resetQuestionFields;
        self.getNewQuestions = getNewQuestions;
        self.getAnsweredQuestions = getAnsweredQuestions;
        self.getIgnoredQuestions = getIgnoredQuestions;
        self.ignoreQuestion = ignoreQuestion;
        self.markQuestionAsNew = markQuestionAsNew;
        self.currentList = self.getNewQuestions();
        self.selected = null;
        self.editQuestion = editQuestion;
        self.submitQuestion = submitQuestion;

        $scope.$on('show-modal', self.onShowModal);
        $scope.$on('hide-modal', self.onHideModal);

        self.questionText = '';
        self.questionFrom = '';

        self.selectedItemForUpdate = null;

        self.getNewCount = getNewCount;
        self.getAnsweredCount = getAnsweredCount;
        self.getIgnoredCount = getIgnoredCount;
        self.displayQuestion = displayQuestion;

        self.generateQuestionNumbering = generateQuestionNumbering;
        self.questionListsUpdated = questionListsUpdated;
        self.isInQandAMode = false;

        self.genericGravatarImg =
            helperService.getLocationProtocol() +
            '://' +
            helperService.getLocationHost() +
            '/AccountManager/images/default-avatar-40-im.png';

        $rootScope.$on('question-lists-updated', self.questionListsUpdated);
        $rootScope.$on('start-qa-mode', onStartedQandAMode);
        self.init = init;

        self.getRenewTooltip = getRenewTooltip;
        self.init();
        ////////////////////////

        function init() {
            var msgObj = {
                message: 'retrieve-questions',
                data: {}
            };

            socketService.send(msgObj);
        }

        function onStartedQandAMode(evt, question) {
            if (self.mode === 'edit-question' && self.selectedItemForUpdate.qaid === question.qaid) {
                $window.swal({
                    title: localizationService.translate('Q_AND_A.ANOTHER_QANDA.TITLE'),
                    text: localizationService.translate('Q_AND_A.ANOTHER_QANDA.TEXT'),
                    confirmButtonColor: brandingService.getBaseColor(),
                    type: 'warning'
                });
                self.setMode('question-list');
            }
        }

        function markQuestionAsNew(question) {
            questionService.markQuestionAsNew(question);
            self.currentList = self.tab === 'ignored' ? self.getIgnoredQuestions() : self.getAnsweredQuestions();
            digest();
        }

        function ignoreQuestion(question) {
            questionService.markQuestionAsIgnored(question);
            self.currentList = self.getNewQuestions();
            digest();
        }

        function getNewQuestions() {
            return questionService.getNewQuestions();
        }

        function displayQuestion(question) {
            if (meetingService.getIsOnAir() === false) {
                $window.swal({
                    title: localizationService.translate('Q_AND_A.NOT_ON_AIR.TITLE'),
                    text: localizationService.translate('Q_AND_A.NOT_ON_AIR.TEXT'),
                    confirmButtonColor: brandingService.getBaseColor(),
                    confirmButtonText: localizationService.translate('COMMON.OK_TEXT'),
                    type: 'warning'
                });
            } else if (contentService.isContentPlaying() && contentService.getContentType() === 'screenshare') {
                $window.swal({
                    title: localizationService.translate('Q_AND_A.ON_SCREENSHARE.TITLE'),
                    text: localizationService.translate('Q_AND_A.ON_SCREENSHARE.TEXT'),
                    confirmButtonColor: brandingService.getBaseColor(),
                    confirmButtonText: localizationService.translate('COMMON.OK_TEXT'),
                    type: 'warning'
                });
            } else if (contentService.isContentPlaying() && contentService.getContentType() === 'video') {
                $window.swal({
                    title: localizationService.translate('Q_AND_A.ON_VIDEO.TITLE'),
                    text: localizationService.translate('Q_AND_A.ON_VIDEO.TEXT'),
                    confirmButtonColor: brandingService.getBaseColor(),
                    confirmButtonText: localizationService.translate('COMMON.OK_TEXT'),
                    type: 'warning'
                });
            } else if (pollingService.getIsVoting()) {
                $window.swal({
                    title: localizationService.translate('Q_AND_A.ON_VOTING.TITLE'),
                    confirmButtonColor: brandingService.getBaseColor(),
                    confirmButtonText: localizationService.translate('COMMON.OK_TEXT'),
                    type: 'warning'
                });
            } else {
                questionService.startQandAMode(question);
                self.modalState = 'closed';
            }
        }

        function questionListsUpdated() {
            toggleTab(self.tab);
            digest();
        }

        function getAnsweredQuestions() {
            return questionService.getAnsweredQuestions();
        }

        function getIgnoredQuestions() {
            return questionService.getIgnoredQuestions();
        }

        function getTitle() {
            var title = '';
            switch (self.mode) {
                case 'question-list':
                    title = localizationService.translate('Q_AND_A.Q_AND_A');
                    break;
                case 'question':
                    title = localizationService.translate('Q_AND_A.NEW_QUESTION');
                    break;
                case 'edit-question':
                    title = localizationService.translate('Q_AND_A.EDIT_QUESTION');
                    break;
                default:
                    break;
            }
            return title;
        }

        function checkForModificationAndSetMode() {
            if (self.mode === 'edit-question') {
                if (
                    self.selectedItemForUpdate.question !== self.questionText ||
                    self.selectedItemForUpdate.attendantName !== self.questionFrom
                ) {
                    $window.swal(
                        {
                            title: localizationService.translate('Q_AND_A.DISCARD_CHANGES.TITLE'),
                            type: 'warning',
                            showCancelButton: true,
                            cancelButtonText: localizationService.translate('COMMON.CANCEL_TEXT'),
                            confirmButtonColor: brandingService.getBaseColor(),
                            confirmButtonText: localizationService.translate('Q_AND_A.CONFIRM_DISCARD'),
                            closeOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                self.setMode('question-list');
                            } else {
                                logger.log('Call to discard changes to question was cancelled');
                            }
                        }
                    );
                } else {
                    self.setMode('question-list');
                }
            } else if (self.mode === 'question') {
                if (self.questionText.trim() !== '' || self.questionFrom.trim() !== '') {
                    $window.swal(
                        {
                            title: localizationService.translate('Q_AND_A.DISCARD_QUESTION.TITLE'),
                            type: 'warning',
                            showCancelButton: true,
                            cancelButtonText: localizationService.translate('COMMON.CANCEL_TEXT'),
                            confirmButtonColor: brandingService.getBaseColor(),
                            confirmButtonText: localizationService.translate('Q_AND_A.CONFIRM_DISCARD'),
                            closeOnConfirm: true
                        },
                        function (isConfirm) {
                            if (isConfirm) {
                                self.setMode('question-list');
                            } else {
                                logger.log('Call to discard question was cancelled');
                            }
                        }
                    );
                } else {
                    self.setMode('question-list');
                }
            }
        }

        function setMode(mode, item) {
            self.mode = mode;
            if (item !== undefined && self.mode === 'edit-question') {
                self.questionText = item.question;
                self.questionFrom = item.attendantName;
                self.selectedItemForUpdate = item;
            } else {
                self.resetQuestionFields();
            }
            digest();
        }

        function getAnsweredCount() {
            return self.getAnsweredQuestions().length;
        }

        function getNewCount() {
            return self.getNewQuestions().length;
        }

        function getIgnoredCount() {
            return self.getIgnoredQuestions().length;
        }

        function toggleTab(tab) {
            self.tab = tab;
            switch (tab) {
                case 'new':
                    self.currentList = self.getNewQuestions();
                    self.spaceFilerText = localizationService.translate('Q_AND_A.THERE_ARENT_ANY_UNREAD_QUESTIONS');
                    break;
                case 'answered':
                    self.currentList = self.getAnsweredQuestions();
                    self.spaceFilerText = localizationService.translate('Q_AND_A.YOU_HAVENT_SHOWN_ANY_QUESTIONS');
                    break;
                case 'ignored':
                    self.currentList = self.getIgnoredQuestions();
                    self.spaceFilerText = localizationService.translate('Q_AND_A.YOU_HAVENT_DISMISSED_ANY_QUESTIONS');
                    break;
                default:
                    break;
            }

            digest();
        }

        function resetQuestionFields() {
            self.questionText = '';
            self.questionFrom = '';
            self.selectedItemForUpdate = null;
        }

        function onHideModal(e, modalName) {
            if (modalName.indexOf('webinarPresenterQA') !== -1) {
                self.modalState = 'closed';
                //self.mode = 'question-list';
                //self.resetQuestionFields();
            }

            digest();
        }

        function onShowModal(e, modalName, newQuestion) {
            if (modalName === 'webinarPresenterQA') {
                self.modalState = 'open';
            }

            if (newQuestion) {
                self.toggleTab('new');
            }
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }

        function droppedItem(event, index, item, external, type, itemType) {
            self.currentList.splice(index, 0, item);
            for (var i = 0; i < self.currentList.length; ++i) {
                if (
                    self.currentList[i].attendantID === item.attendantID &&
                    self.currentList[i].qaid === item.qaid &&
                    i !== index
                ) {
                    self.currentList.splice(i, 1);
                    break;
                }
            }
            self.generateQuestionNumbering();
            questionService.updateNewQuestionsOrdering2(self.currentList);
            self.currentList = self.getNewQuestions();
            digest();
        }

        function generateQuestionNumbering() {
            for (var i = 0; i < self.currentList.length; ++i) {
                self.currentList[i].ordering = i;
            }
        }

        function editQuestion() {
            if (!validateQuestionAndAuthor()) {
                return;
            }

            self.selectedItemForUpdate.question = self.questionText;
            self.selectedItemForUpdate.attendantName = self.questionFrom;
            questionService.editQuestion(self.selectedItemForUpdate);
            self.setMode('question-list');
            digest();
        }

        function validateQuestionAndAuthor() {
            if (
                !self.questionText ||
                self.questionText.trim().length === 0 ||
                !self.questionFrom ||
                self.questionFrom.trim().length === 0
            ) {
                $window.swal({
                    title: localizationService.translate('Q_AND_A.VALIDATE_QUESTION.TITLE'),
                    text: localizationService.translate('Q_AND_A.VALIDATE_QUESTION.TEXT'),
                    confirmButtonColor: brandingService.getBaseColor(),
                    type: 'warning'
                });
                return false;
            }
            return true;
        }

        function submitQuestion() {
            if (!validateQuestionAndAuthor()) {
                return;
            }

            var question = {
                question: self.questionText,
                attendantName: self.questionFrom
            };
            questionService.addQuestion(question);
            generateQuestionNumbering();
            self.currentList = self.getNewQuestions();
            self.setMode('question-list');
            self.toggleTab('new');
            digest();
        }

        function getRenewTooltip() {
            return self.tab === 'ignored'
                ? localizationService.translate('Q_AND_A.UNDO_DISMISS')
                : localizationService.translate('Q_AND_A.RENEW_QUESTION');
        }
    }
]);
